import React from 'react';
import {TextField} from '@sail/ui';
import {COLORS} from 'src/v2/util/color';

interface FormTextFieldProps {
  label: React.ReactNode;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'password' | 'tel' | 'url' | 'search' | 'number';
  error?: string;
}

export const FormTextField = ({
  label,
  placeholder,
  value,
  onChange,
  type,
  error,
}: FormTextFieldProps) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      type={type}
      size="large"
      invalid={!!error}
      error={error}
      subviews={{
        input: {
          css: {
            height: '36px',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            '::placeholder': {
              color: COLORS.textDisabledOnLight,
            },
          },
        },
      }}
    />
  );
};
